function Experience() {
  const myjobs = [
    {
      id: 1,
      role: "Software Developer",
      company: "Smartvision for Information Systems",
      location: "Abu Dhabi, UAE",
      duration: "Sep 2022 - Aug 2023",
      desc: "At Smartvision, I contributed to major government and enterprise projects across the UAE. I developed a backend control management system for Dubai RTA smart kiosks, enabling real-time monitoring of transactions, refunds, escalations, and machine performance. I collaborated with the UI/UX team to design kiosk interfaces, conducted manual testing, and supported other major projects for Al Ansari Exchange and the Crown Prince Court.",
      skillsgained:
        "VB.NET, ASP.NET, C#, Angular, TypeScript, MS SQL Server, Figma UI/UX Wireframing",
    },

    {
      id: 2,
      role: "Software Developer",
      company: "Unity Infotech",
      location: "Dubai, UAE",
      duration: "March 2022 - Sep 2022",
      desc: "At Unity Infotech, I contributed to high-profile client projects for major UAE financial institutions. My responsibilities included developing and implementing application modules using .NET and C#, applying clean architecture principles, dependency injection, and code-first methodologies in ASP.NET Core.I also worked with Azure cloud services and achieved the Microsoft Certified Azure Developer Associate (AZ-204) certification.",
      skillsgained: "C#, ASP.NET Core, Azure Cloud Services",
    },

    {
      id: 3,
      role: "Junior Web Developer",
      company: "Cosmicvent Software",
      location: "Hyderabad, India",
      duration: "May 2019 - Nov 2021",
      desc: "As a Junior Web Developer, I supported the full software development lifecycle by preparing detailed documentation, collaborating with frontend and backend teams, and gaining hands-on experience with Angular and ASP.NET.I also worked alongside database administrators to create SQL jobs, write stored procedures, and generate RDLC and Crystal Reports for various business requirements.",
      skillsgained:
        "C#, TypeScript, JavaScript, HTML/CSS, SQL Server, Angular, ASP.NET, .NET Core",
    },
  ];

  return (
    <div>
      {myjobs.map((job) => (
        <div class="card shadow border-0 rounded-4 mb-5">
          <div class="card-body p-5">
            <div class="row align-items-center gx-5">
              <div class="col text-center text-lg-start mb-4 mb-lg-0">
                <div class="bg-light p-4 rounded-4">
                  <div class="text-primary fw-bolder mb-2">{job.duration}</div>
                  <div class="small fw-bolder">{job.role}</div>
                  <div class="small text-muted">{job.company}</div>
                  <div class="small text-muted">{job.location}</div>
                </div>
              </div>
              <div class="col-lg-8">
                <div>{job.desc}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Experience;
